import { Empty, List, Skeleton } from 'antd'
import AddBlueIcon from 'components/icons/AddBlueIcon'
import { AddLinkspan } from 'modules/Settings/Components/AddtionalInfo/style'
import {
  CommonFlex,
  RightSection,
} from 'modules/Settings/Components/CompanyInfo/style'
import AddLocationDrawer from 'modules/Settings/Components/Location/AddLocationDrawer/index'
import LocationInfo from 'modules/Settings/Components/Location/LocationInfo'
import {
  AddLocationButton,
  ComanyDiv,
  NoDataDiv,
  ScrollWrapper,
} from 'modules/Settings/Components/Location/style'
import { MainWrapper } from 'modules/Settings/Styles/style'
import React, { Fragment, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

const Location = ({
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,

  getCorporateLocationsList,
  corporateLocationsList,
  addCorporateBranch,
  getLocationDetails,
  singleLocationData,
  updateLocationAPI,
  deleteLocationAPI,
}) => {
  const [addLocation, setAddLocation] = useState(false)
  const [selectedLocationId, setSelectedLocationId] = useState('')

  const [hasMoreData, setHasMoreData] = useState(true)
  const [pageNo, setPageNo] = useState(1)
  const [locationLoading, setLocationLoading] = useState(false)

  const [locations, setLocations] = useState([])
  const [pageChangeCount, setPageChangeCount] = useState(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    loadMoreData()
  }, [pageNo, pageChangeCount])

  const onEditClick = async locationId => {
    setLoading(true)

    try {
      const { status } = await getLocationDetails(locationId)

      if (status >= 200 && status <= 300) {
        setSelectedLocationId(locationId)
        setAddLocation(true)
      }
    } catch (error) {
      console.error('Error fetching location details:', error)
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    }
  }

  const onDelete = async locationId => {
    const { status } = await deleteLocationAPI({
      locationId: locationId,
    })
    if (status >= 200 && status <= 300) {
      resetScrollData()
    }
  }

  const handleLocationData = async payload => {
    if (selectedLocationId) {
      let { status } = await updateLocationAPI({
        payload: payload,
        locationId: selectedLocationId,
      })
      if (status >= 200 && status <= 300) {
        resetScrollData()
        return true
      }
    } else {
      let { status } = await addCorporateBranch({
        payload: payload,
      })
      if (status >= 200 && status <= 300) {
        resetScrollData()
        return true
      }
    }
  }

  const loadMoreData = async () => {
    const { data } = await getCorporateLocationsList({
      pageLimit: 10,
      currentPage: pageNo,
      setLoading: setLocationLoading,
    })

    if (data?.data?.list?.length) {
      const pendingList =
        pageNo == 1
          ? [...(data?.data?.list || [])]
          : [...locations, ...(data?.data?.list || [])]
      setLocations(pendingList)
    } else {
      setLocations([])
      setHasMoreData(false)
    }
    if (data?.data?.totalPages == 1) {
      setHasMoreData(false)
    }
  }

  const fetchMoreData = () => {
    if (corporateLocationsList?.totalPages == pageNo) {
      setHasMoreData(false)
      return
    }
    setPageNo(prev => prev + 1)
  }

  const resetScrollData = () => {
    setPageNo(1)
    setHasMoreData(true)
    setPageChangeCount(prev => prev + 1)
  }

  return (
    <>
      <MainWrapper marginBottom="0px">
        <CommonFlex spaceBetween>
          <ComanyDiv>Location</ComanyDiv>
          <RightSection>
            <AddLocationButton
              onClick={() => setAddLocation(true)}
              text={<AddLinkspan>Add Location</AddLinkspan>}
              icon={<AddBlueIcon />}
            />
          </RightSection>
        </CommonFlex>

        {locations?.length ? (
          <ScrollWrapper>
            <InfiniteScroll
              dataLength={locations.length}
              next={fetchMoreData}
              hasMore={hasMoreData}
              loader={
                hasMoreData ? (
                  <Skeleton avatar paragraph={{ rows: 2 }} active />
                ) : null
              }
              height={'53vh'}
            >
              <List
                bordered={false}
                dataSource={locations}
                loading={locationLoading}
                renderItem={item => (
                  <Fragment key={item?.id}>
                    <List.Item>
                      <LocationInfo
                        key={item?.id}
                        id={item?.id}
                        branchName={item?.branchName}
                        city={item?.city}
                        state={item?.state}
                        country={item?.country}
                        defaultLocation={item?.defaultLocation}
                        onEditClick={onEditClick}
                        onDelete={onDelete}
                      />
                    </List.Item>
                  </Fragment>
                )}
              />
            </InfiniteScroll>
          </ScrollWrapper>
        ) : (
          <NoDataDiv>
            <Empty description="No locations added" />
          </NoDataDiv>
        )}
      </MainWrapper>
      <AddLocationDrawer
        addLocation={addLocation}
        setAddLocation={setAddLocation}
        getListOfCountries={getListOfCountries}
        getListOfStates={getListOfStates}
        getListOfCities={getListOfCities}
        listOfCountries={listOfCountries}
        listOfStates={listOfStates}
        listOfCities={listOfCities}
        selectedLocationId={selectedLocationId}
        setSelectedLocationId={setSelectedLocationId}
        handleLocationData={handleLocationData}
        addCorporateBranch={addCorporateBranch}
        setLocationLoading={setLocationLoading}
        singleLocationData={singleLocationData}
        loading={loading}
        setLoading={setLoading}
      />
    </>
  )
}

export default Location
